import { useState } from 'react';
import { AxiosPrivate } from '../utils/axios';

export const useGetUser = () => {
  const [isFetching, setFetching] = useState(false);

  return {
    isFetching,
    getUser: async id => {
      try {
        setFetching(true);
        const response = await AxiosPrivate.get(`/users/${id}`);
        setFetching(false);
        return response;
      } catch (e) {
        setFetching(false);
      }
    },
  };
};
